import { Button, Typography } from '@mui/material';
import Link from '@mui/material/Link';
import type { TypographyProps } from '@mui/material/Typography';
import { tracker } from 'app-components/utils/core';
import zillow from 'assets/logos/zillow.png';
import React from 'react';

export const ZillowImage = (styling: string, trackerProp: string, link?: string) => (
  <a
    onClick={() => tracker.track(trackerProp, { logo: true })}
    target='_blank'
    rel='noopener noreferrer'
    href={link || 'http://www.zillow.com/'}
  >
    <img className={styling} src={zillow} alt='Real Estate on Zillow' />
  </a>
);

export const ZillowTerms = (styling: string, trackerProp: string) => (
  <Typography variant='captionRegular' className={styling}>
    <Typography variant='captionRegular'>© Zillow, Inc., 2006-2019. Use is subject to the </Typography>
    <Link
      onClick={() => tracker.track(trackerProp, { terms: true })}
      href='https://bridgedataoutput.com/zillowterms'
      target='_blank'
      rel='noopener noreferrer'
    >
      Zillow Terms of Use.
    </Link>
  </Typography>
);

export const PropertyDialogNavigationButton = ({
  containerClass,
  styleClass,
  handleDialogNavigation,
  icon,
  buttonText,
  description,
  textVariant,
}: {
  containerClass: string;
  styleClass: string;
  handleDialogNavigation: () => void;
  icon: React.ReactNode;
  buttonText: string;
  description: string;
  textVariant: TypographyProps['variant'];
}) => (
  <div className={containerClass}>
    <Button onClick={handleDialogNavigation} endIcon={icon} className={styleClass}>
      {buttonText}
    </Button>
    <Typography variant={textVariant}>{description}</Typography>
  </div>
);
